import {
  MdBusiness,
  MdCheckCircle,
  MdHandshake,
  MdLocationCity,
  MdSecurity,
  MdStar,
  MdTrendingUp,
} from "react-icons/md";
import {
  currentClients,
  targetClients,
} from "./RunzeweContent";

const clientAssurance = [
  {
    icon: <MdSecurity />,
    title: "Licensed Operations",
    text: "Permitted by the Office of the IGP and structured for compliant private security delivery.",
  },
  {
    icon: <MdLocationCity />,
    title: "Multi-Region Experience",
    text: "Serving assignments in Geita and Zanzibar with approved expansion coverage across Tanzania.",
  },
  {
    icon: <MdHandshake />,
    title: "Tailored Site Plans",
    text: "Security programs are adjusted to each client's premises, risk level, traffic, and operating hours.",
  },
  {
    icon: <MdTrendingUp />,
    title: "Growth Ready",
    text: "Company milestones include patrol vehicle acquisition, armed services expansion, and nationwide branches.",
  },
];

export default function ClientsContent() {
  return (
    <>
      <section className="page-hero clients-page-hero">
        <div className="page-hero-overlay" />
        <div className="container page-hero-content" data-aos="fade-up">
          <p className="section-kicker">Clients & Sectors</p>
          <h1>Trusted by Institutions, Businesses, and Communities.</h1>
          <p>
            Runzewe serves schools, health facilities, hotels, residences,
            markets, construction sites, and business premises across Tanzania
            and Zanzibar.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Current Clients</p>
            <h2>Experience across public, private, and hospitality sites.</h2>
          </div>

          <div className="client-grid">
            {currentClients.map((client, index) => (
              <div className="client-card" key={client} data-aos="fade-up" data-aos-delay={(index % 4) * 60}>
                <MdCheckCircle />
                <span>{client}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="content-section section-soft">
        <div className="container">
          <div className="split-grid">
            <div data-aos="fade-right">
              <p className="section-kicker">Target Clients</p>
              <h2>Prepared for many operating environments.</h2>
              <p>
                Runzewe designs security programs for single sites and
                multi-location clients, balancing guard presence, technical
                controls, supervision, and reporting.
              </p>

              <div className="target-list">
                {targetClients.map((client, index) => (
                  <span key={client} data-aos="fade-up" data-aos-delay={(index % 2) * 70}>
                    <MdBusiness />
                    {client}
                  </span>
                ))}
              </div>
            </div>

            <div className="client-highlight-card" data-aos="fade-left">
              <MdStar />
              <h3>Service Experience</h3>
              <p>
                Current engagements include educational institutions, health
                centres, hotel projects, petrol stations, residences, churches,
                markets, and Zanzibar hospitality destinations.
              </p>
              <div>
                <strong>{currentClients.length}+</strong>
                <span>listed client assignments</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Client Assurance</p>
            <h2>Why clients trust Runzewe with sensitive premises.</h2>
          </div>

          <div className="assurance-grid">
            {clientAssurance.map((item, index) => (
              <div className="assurance-card" key={item.title} data-aos="zoom-in" data-aos-delay={index * 70}>
                <div>{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
